<template lang="pug">
section.subpage.profile.pb-5(ref="subpage",v-if="$auth.isAuthenticated && $parent.currentUser")
  h2.title
    .d-flex.w-100
      div
        span {{ page.title }}
        small.text-muted.ml-3 ※ 個人ごとの設定となります
      .ml-auto
        b-form-checkbox.ml-3(switch,v-model="isUse")

  ValidationObserver(slim,ref="observer")
    b-form(ref="form",@submit.prevent)
      b-container(fluid,v-if="datum && datum.notifications")
        b-row
          b-col
            h5 通知する曜日
            .my-3
              .d-flex
                b-form-checkbox.mr-2(v-model="datum.notifications.weekly[0]",@input="validateInput") 日
                b-form-checkbox.mr-2(v-model="datum.notifications.weekly[1]",@input="validateInput") 月
                b-form-checkbox.mr-2(v-model="datum.notifications.weekly[2]",@input="validateInput") 火
                b-form-checkbox.mr-2(v-model="datum.notifications.weekly[3]",@input="validateInput") 水
                b-form-checkbox.mr-2(v-model="datum.notifications.weekly[4]",@input="validateInput") 木
                b-form-checkbox.mr-2(v-model="datum.notifications.weekly[5]",@input="validateInput") 金
                b-form-checkbox.mr-2(v-model="datum.notifications.weekly[6]",@input="validateInput") 土
                b-form-checkbox.mr-2(v-model="datum.notifications.holiday",@input="validateInput") 祝日
            h5 通知する内容
            .mt-3
              label.h6 週次
              .ml-3
                .ml-3
                  b-form-checkbox(v-model="datum.notifications.subjects.weeklyCondition",@input="validateInput") 採用コンディション（月曜）

            .mt-3
              label.h6 日次
              .ml-3
                .ml-3
                  b-form-checkbox(v-model="datum.notifications.subjects.dailyUndecided",@input="validateInput") 選考未設定アラート
                  b-form-checkbox(v-model="datum.notifications.subjects.dailyUnevaluated",@input="validateInput") 選考結果未入力アラート

            .mt-3
              label.h6 随時
              .ml-3
                .ml-3
                  b-form-checkbox(v-model="datum.notifications.subjects.peoplePost",@input="validateInput") 候補者登録
                  b-form-checkbox(v-model="datum.notifications.subjects.peopleDelete",@input="validateInput") 候補者削除
                  b-form-checkbox(v-model="datum.notifications.subjects.messagePost",@input="validateInput") コメント入力
                  b-form-checkbox(v-model="datum.notifications.subjects.schedulePost",@input="validateInput") 選考設定完了
                  b-form-checkbox(v-model="datum.notifications.subjects.selectorChoose",@input="validateInput") 選考官割当
                  b-form-checkbox(v-model="datum.notifications.subjects.resultPost",@input="validateInput") 選考結果入力
                  b-form-checkbox(v-model="datum.notifications.subjects.offerPost",@input="validateInput") 内定
                  b-form-checkbox(v-model="datum.notifications.subjects.engagePost",@input="validateInput") 内定受諾
                  b-form-checkbox(v-model="datum.notifications.subjects.refusePost",@input="validateInput") 内定辞退
                  b-form-checkbox(v-model="datum.notifications.subjects.expectPost",@input="validateInput") 入社決定
                  b-form-checkbox(v-model="datum.notifications.subjects.keepPatch",@input="validateInput") 保留
                  b-form-checkbox(v-model="datum.notifications.subjects.keepoffPatch",@input="validateInput") 保留解除
      footer.buttons
        b-button(variant="primary",@click="onSave()",:disabled="!valid || !changed")
          span 保存
</template>

<script>
import { isEqual } from 'lodash'

import { getData, patchData } from '../utils/api'

import { clone, difference } from '../utils/libs'

const page = {
  id: 'preference',
  title: '通知設定'
}

export default {
  name: page.id,
  data () {
    return {
      mask: false,
      page: page,
      changed: false,
      valid: false,
      isUse: true,
      datum: {},
      recentDatum: {}
    }
  },
  watch: {
    async isUse (val) {
      if (!this.mask) {
        try {
          await patchData(`/preference/notice`, { reject: !val })
        } catch (e) {
          this.msgBoxError('Failed Change')
        }
      }
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async validateInput () {
      this.valid = await this.$refs.observer.validate()

      const diffDatum = difference(this.datum, this.recentDatum)
      if (!isEqual({}, diffDatum)) {
        this.changed = true
      }
      this.recentDatum = clone(this.datum)
    },
    async loadData () {
      if (!this.$root.currentUser || !this.$root.currentUser.role) {
        setTimeout(() => {
          this.loadData()
        }, 300)
        return
      }

      this.mask = true

      let message = ''

      this.isUse = true

      try {
        await getData(`/preference`).then((datum) => {
          if (datum) {
            this.datum = clone(datum)

            if (!this.datum.notifications) {
              this.datum.notifications = {}
            }

            if (this.datum.notifications.reject) {
              this.isUse = false
            }

            if (!this.datum.notifications.weekly) {
              this.datum.notifications.weekly = []
            }
            if (!this.datum.notifications.subjects) {
              this.datum.notifications.subjects = {}
            }
          }
        }).catch((err) => {
          console.log(err)
          message = 'データの読込に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })

        // this.validateInput()

        this.changed = false
        this.valid = false
      } catch (e) {
        message = 'データの読込に失敗しました'
      }

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      }

      this.$parent.$refs.header.checkCondition()

      this.$forceUpdate()
    },
    async onSave () {
      await this.validateInput()
      this.valid = await this.$refs.observer.validate()

      if (!this.valid) {
        this.msgBoxError('Invalid Inputs')
      } else {
        this.msgBoxConfirm('通知設定を保存しますか？', this.doSave)
      }
    },
    async doSave () {
      this.mask = true

      let datum = clone(this.datum)

      if (datum.notifications) {
        delete datum.notifications.reject
      }

      delete datum.companyId
      delete datum.userId

      delete datum.postedAt
      delete datum.PostedBy
      delete datum.patchedAt
      delete datum.PatchedBy

      delete datum._id

      let message = null

      try {
        await patchData(`/preference`, datum).then((json) => {
          this.loadData()
        }).catch((err) => {
          console.log(err)
          message = 'データの保存に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })
      } catch (e) {
        console.log(e)
        message = 'データの保存に失敗しました'
      }

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      } else {
        this.$forceUpdate()
      }
    }
  }
}
</script>

<style scoped lang="stylus">
//.form-group
  >>> label::after
    display none
.custom-switch
  >>> label::after
    display block
</style>
